import React from "react";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import Link from "@mui/material/Link";

export const AugustaGreenJacketsLink = () => (
  <Link
    href={
      "https://mlb.tickets.com/?orgid=56772&agency=AGRM_MYTIXX#/auth/login?fullret=%2Fticketmanagement%2F%3Forgid%3D56772%26agency%3DAGRM_MYTIXX"
    }
    target={"_blank"}
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => (
    <>
      We are going to apply the same or similar seats to all games in your pack.
      Seat locations will be visible on the checkout page.
    </>
  ),
  progressBarText: "Add 2 games and get 20% off your tickets.",
  progressBarAditionalText: " to continue and get 20% off!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Pack",
    description: "Select which 7-Game Holiday Pack you'd like.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MiLB.com",
    description:
      "Click Continue and connect your GreenJackets Ticketing account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <AugustaGreenJacketsLink /> Account in
        March 2025.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the GreenJackets Holiday Pack work?",
    description:
      "The GreenJackets Holiday Pack allows fans to select one or two seats in a 7 game pack for savings this holiday season! Simply log into your MLB.com to get started.",
  },
  {
    title: "Can I only select games in the Holiday Pack?",
    description: "Yes you can only select the games in the Holiday Pack.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets will be available in your <AugustaGreenJacketsLink /> Account in
        March 2025. If you are purchasing as a Holiday Gift, please contact the
        GreenJackets Front Office at{" "}
        <Link
          href="tel:8033499402"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          (803) 349-9402
        </Link>
        . For those that purchase 2 seats, $20 Gift Cards can be picked up at
        the SRP Park Box Office the week of December 16th with proof of Holiday
        Pack Purchase. SRP Park Box Office Hours are 10am-5pm December 16-20
      </>
    ),
  },
];
